import { MOSCOW_REGION_ID, SPB_REGION_ID } from 'shared/constants/regions';
import { ILocation, TLocation } from 'shared/types/location';

export function getBoundedBy(currentLocation: TLocation, regions: ILocation[]) {
  const defaultLocation = typeof currentLocation !== 'string' ? currentLocation : undefined;

  const location =
    regions.find(({ id }) => {
      if (currentLocation === 'moscow_mo') {
        return id === MOSCOW_REGION_ID;
      }
      if (currentLocation === 'spb_lo') {
        return id === SPB_REGION_ID;
      }

      return id === currentLocation.parentId;
    }) || defaultLocation;

  if (!location || !location.boundedBy) {
    return undefined;
  }

  return [
    [location.boundedBy.upperCorner?.lat, location.boundedBy.upperCorner?.lng],
    [location.boundedBy.lowerCorner?.lat, location.boundedBy.lowerCorner?.lng],
  ] as [YMaps.TCoord, YMaps.TCoord];
}
